import { combineReducers } from 'redux';
import SalesSession from './SalesSession';
import Deposit from './Deposit';
import BankReconciliation from './BankReconciliation';
import DepositMigration from './DepositMigration';
import UnitHome from './UnitHome';
import GeneralIncome from './GeneralIncome';
import Expense from './Expense';
import PricingProfile from './PricingProfile';
import LiquidationSession from './LiquidationSession';
import DiscountToBeneficiary from './DiscountToBeneficiary';
import ExpenseStatus from './ExpenseStatus';
import CreditNote from './CreditNote';
import DiscountCode from './DiscountCode';
import DiscountCodeCategory from './DiscountCodeCategory';
import DiscountCodeSubCategory from './DiscountCodeSubCategory';
import DiscountCodeAuthorizer from './DiscountCodeAuthorizer';
import PricingProfileDateRange from './PricingProfileDateRange';
import PricingProfileMassiveUpdate from './PricingProfileMassiveUpdate';
import FreeOfChargeCategory from './FreeOfChargeCategory';
import FreeOfChargeRule from './FreeOfChargeRule';
import UnreturnedAmount from './UnreturnedAmount';
import SalesSessionDebitNote from './SalesSessionDebitNote';

export default combineReducers({
  SalesSession,
  Deposit,
  BankReconciliation,
  DepositMigration,
  GeneralIncome,
  Expense,
  UnitHome,
  PricingProfile,
  LiquidationSession,
  DiscountToBeneficiary,
  ExpenseStatus,
  CreditNote,
  DiscountCode,
  DiscountCodeCategory,
  DiscountCodeSubCategory,
  DiscountCodeAuthorizer,
  PricingProfileDateRange,
  PricingProfileMassiveUpdate,
  FreeOfChargeCategory,
  FreeOfChargeRule,
  UnreturnedAmount,
  SalesSessionDebitNote,
});
